var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdsObjectiveProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10505_56277)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 12,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 11.5,
    stroke: "#F9ED33",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4998 37.5402H22.4998C20.9598 37.5402 19.6764 37.3886 18.5914 37.0619C18.1948 36.9453 17.9381 36.5602 17.9614 36.1519C18.2531 32.6636 21.7881 29.9219 25.9998 29.9219C30.2114 29.9219 33.7348 32.6519 34.0381 36.1519C34.0731 36.5719 33.8164 36.9453 33.4081 37.0619C32.3231 37.3886 31.0398 37.5402 29.4998 37.5402ZM19.8398 35.5686C20.6098 35.7202 21.4848 35.7902 22.4998 35.7902H29.4998C30.5148 35.7902 31.3898 35.7202 32.1598 35.5686C31.5414 33.3286 28.9864 31.6719 25.9998 31.6719C23.0131 31.6719 20.4581 33.3286 19.8398 35.5686Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4997 13.332H22.4997C16.6663 13.332 14.333 15.6654 14.333 21.4987V28.4987C14.333 32.9087 15.663 35.3237 18.8363 36.222C19.093 33.1887 22.208 30.797 25.9997 30.797C29.7913 30.797 32.9063 33.1887 33.163 36.222C36.3363 35.3237 37.6663 32.9087 37.6663 28.4987V21.4987C37.6663 15.6654 35.333 13.332 29.4997 13.332ZM25.9997 27.5303C23.6897 27.5303 21.823 25.6521 21.823 23.3421C21.823 21.0321 23.6897 19.1654 25.9997 19.1654C28.3097 19.1654 30.1763 21.0321 30.1763 23.3421C30.1763 25.6521 28.3097 27.5303 25.9997 27.5303Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9999 28.4079C23.2116 28.4079 20.9482 26.133 20.9482 23.3447C20.9482 20.5563 23.2116 18.293 25.9999 18.293C28.7882 18.293 31.0516 20.5563 31.0516 23.3447C31.0516 26.133 28.7882 28.4079 25.9999 28.4079ZM25.9999 20.043C24.1799 20.043 22.6982 21.5247 22.6982 23.3447C22.6982 25.1763 24.1799 26.6579 25.9999 26.6579C27.8199 26.6579 29.3016 25.1763 29.3016 23.3447C29.3016 21.5247 27.8199 20.043 25.9999 20.043Z",
    fill: "#292D32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10505_56277",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10505_56277"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10505_56277",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdsObjectiveProfile);
export default __webpack_public_path__ + "static/media/ads-objective-profile.faff45a905af370805f7cbde7c782d42.svg";
export { ForwardRef as ReactComponent };